import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UsuarioTenant } from '../models/usuariotenant.model';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UsuariotenantService {

        url = `${environment.url}/api`;

          constructor(
            private http: HttpClient
          ) { }


    getUsuariosTenants(): Observable<UsuarioTenant[]> {
        return this.http.get<UsuarioTenant[]>(`${this.url}/usuariostenants`);
    }

    getUsuarioTenant(id: number): Observable<UsuarioTenant> {
        return this.http.get<UsuarioTenant>(`${this.url}/usuariostenants/${id}`);
    }

    createUsuarioTenant(data: UsuarioTenant): Observable<UsuarioTenant> {
        return this.http.post<UsuarioTenant>(`${this.url}/usuariostenants`, data);
    }

    updateUsuarioTenant(id: number, data: UsuarioTenant): Observable<UsuarioTenant> {
        return this.http.put<UsuarioTenant>(`${this.url}/usuariostenants/${id}`, data);
    }

    deleteUsuarioTenant(id: number): Observable<any> {
        return this.http.delete<any>(`${this.url}/usuariostenants/${id}`);
    }

}

